// extracted by mini-css-extract-plugin
export default {"sectionTitle":"lHI57D","grid":"JXuNj3"};